import { WorkspaceSeedListRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/seed-lists/$seedListId')({
  component: WorkspaceSeedListRoute,
});
